<template>
  <div class="integral-home white page-box">
    <div class="header content-header">
      <el-date-picker
        v-if="!realMobile"
        style="width: 260px"
        class="mar-bot10 header-item"
        size="small"
        v-model="pickerTime"
        type="daterange"
        align="left"
        value-format="yyyy-MM-dd HH:mm:ss"
        unlink-panels
        :range-separator="phFileter('root.dateTo')"
        :start-placeholder="phFileter('root.startDate')"
        :end-placeholder="phFileter('root.endDate')"
      >
      </el-date-picker>
      <select-date-duration
        class="header-item"
        v-model="pickerTime"
      ></select-date-duration>
      <el-select
        style="width: 120px"
        size="small"
        class="Recharge mar-bot10 header-item"
        v-model="type"
        :placeholder="phFileter('Points_type')"
        clearable
      >
        <el-option
          v-for="item in typeList"
          :key="item.payType"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        style="width: 130px"
        size="small"
        class="query-status mar-bot10 header-item"
        v-model="status"
        clearable
        :placeholder="phFileter('User.status')"
      >
        <el-option
          v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-button
        class="mar-bot10"
        size="small"
        type="primary"
        @click="queryHandle"
      >{{$t('root.search')}}</el-button>
      <el-button
        class="mar-bot10 header-item"
        size="small"
        @click="clearHandle"
      >{{$t('withgold.clearEmipt')}}</el-button>
    </div>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table :noDataText="$t('root.noData')" :data="listData">
          <template
            slot="thead"
          >
            <vs-th>
              {{$t('User.num')}}
            </vs-th>
            <vs-th>
              {{$t('Points_type')}}
            </vs-th>

            <vs-th>
              {{$t('behavior_type')}}
            </vs-th>
            <vs-th>
              {{$t('Transaction_deposit_amount')}}
            </vs-th>
            <vs-th>
              {{$t('Number_of_points')}}
            </vs-th>

            <vs-th>
              {{$t('bonus_time')}}
            </vs-th>
            <vs-th>
              {{$t('withgold.ExpireDate')}}
            </vs-th>
            <vs-th>
              {{$t('User.status')}}
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr style="background-color:#F3F2F7;">
              <vs-td>
                {{$t('total')}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td>
                {{statistics.transPointAmount}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td>
                {{'-'}}
              </vs-td>
              <vs-td class="">
                {{'-'}}
              </vs-td>
            </vs-tr>
            <vs-tr :key="index" v-for="(tr, index) in data">
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{getType(tr)}}
              </vs-td>

              <vs-td>
                {{getSecondType(tr)}}
              </vs-td>
              <vs-td>
                {{getDealInfo(tr)}}
              </vs-td>
              <vs-td>
                {{tr.earnedPoint}}
              </vs-td>

              <vs-td>
                {{tr.createTime}}
              </vs-td>
              <vs-td>
                {{tr.expiredTime}}
              </vs-td>
              <vs-td>
                {{getStatus(tr.status)}}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import  { mapGetters } from 'vuex';
import { parseTime } from '@/utils/index'
import initData from '@/mixins/initData';
import { parseStatus } from '@/utils/common';
export default {
  name: 'integralHome',
  data() {
    let _this = this;
    return {
      type: '',
      typeList:[
        {
          label: _this.$t('Trading_Points'),
          value: 1
        },
        {
          label: _this.$t('behavioral_points'),
          value: 2
        },
      ],
      statusList:[
        {
          value: 1,
          label: _this.$t('withgold.withgoldOut1')
        },
        {
          value: 4,
          label: _this.$t('invalid')
        },
        {
          value: 3,
          label: _this.$t('valid')
        },
        {
          value: 2,
          label: _this.$t('withgold.withgoldOut3')
        }
      ],
      status: '',
      pickerTime: '',
      statistics: {
        transPointAmount: '',
      }
    }
  },
  mixins: [initData],
  created(){
    this.$nextTick(() => {
      this.init().then((res) => {
      });
    })
  },
  computed: {
    ...mapGetters(['language','userInfo','realMobile']),
  },
  methods: {
    parseTime,
    parseStatus,
    getType(row){
       return row.rewardType == 1 ? this.$t('Trading_Points'): this.$t('behavioral_points');
    },
    getSecondType(row){
      if(row.rewardType == 1){
        return '-'
      }
      return row.actionType == 1 ? this.$t('first_deposit'): this.$t('single_deposit');
    },
    getDealInfo(row){
      let str = '';
      if(row.rewardType == 1){
        str = row.baseValue + this.$t('Home.forexLot');
      }else {
        str = '$' + row.baseValue;
      }
      return `${str} (${row.login})`
    },
    getStatus(status){
      switch (status){
        case 1:
          return this.$t('withgold.withgoldOut1');
        case 2:
          return this.$t('withgold.withgoldOut3');
        case 3:
          return this.$t('valid');
        case 4:
          return this.$t('invalid');
      }
    },
    beforeInit(){
      this.url = '/crm/reception/rewardPointInfo';
      this.params = {
        page: this.page -1,
        size: this.size,
      };
      if(this.type){
        this.params.rewardType = this.type;
      }
      if(this.status){
        this.params.status = this.status;
      }
      if(this.pickerTime){
        this.params.startTime = this.pickerTime[0];
        this.params.endTime = this.pickerTime[1];
      }
      return true;
    },
    phFileter(data){
      return this.$t(data)
    },
    //  清空
    clearHandle(){
      this.type = '';
      this.pickerTime = '';
      this.status = '';
    },
    queryHandle(){
      this.page = 1;
      this.init();
    },
    getStatusMinWidth(){
      if(this.language == 'en_US'){
        return '150px';
      }else {
        return '';
      }
    }
  },
};
</script>
<style lang="scss">
.integral-home {
  .el-date-editor--daterange.el-input__inner {
    width: 100%;
  }
}
</style>
<style scoped lang="scss">
.integral-home{
  min-height: 500px;
  .header {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    .header-item {
      margin-right: 5px;
    }
  }
  .pagination-outer {
    padding-left: 0;
  }
}
</style>
